import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import {
  ClockIcon,
  CalendarIcon,
  LocationIcon,
  // ChevronLeftIcon,
} from "../../../components/page-components/icons";
import { stockImages } from "../../../services/stockImages";
import { format, isSameDay } from "date-fns";
import parse from "html-react-parser";
import { shouldShowSingleTime } from "../../../utils/shouldShowSingleTime";
import { Box, Card, Grid, Icon, Typography } from "@mui/material";
import { useRouter } from "next/router";
import { Facebook } from "@mui/icons-material";
import RightArrow from "../../icons/links/right_arrow_circle.svg";

export const EventCard = ({
  appId,
  eventImage,
  eventName,
  // eventLocation,
  eventStart,
  eventEnd,
  eventHours,
  eventUrl,
  legacy = "",
  eventHoursStart,
  eventHoursEnd,
  eventStreet1,
  eventCity,
  legacyEvent,
  safetyCheck = false,
  facebookUrl,
  eventId,
  eventStatus,
  eventState,
  hasVaryingTimes,
}) => {
  
  const [mapsURL, setMapsURL] = useState("");
  const [image, setImage] = useState();
  const router = useRouter();
  const checkImage = () => {
    if (eventImage && eventImage.startsWith("http")) {
      setImage(eventImage);
    } else {
      for (const img of stockImages) {
        if (eventName.toLowerCase().includes(img.venue)) {
          setImage(img.stockImage);
        }
      }
    }
  };

  const getFormattedDate = (date) => {
    if (date !== false || date !== "InvalidDate") {
      try {
        return format(date, "MMM do, yyyy");
      } catch (err) {
        console.log(err);
        return null;
      }
    } else {
      return null;
    }
  };

  const getFormattedTime = (time) => {
    if (time !== false || time !== "InvalidDate") {
      try {
        return format(time, "h:mm aa");
      } catch (err) {
        console.log(err);
        return null;
      }
    } else {
      return null;
    }
  };

  const getMapsURL = (street, city, state) => {
    let streetSplit = street?.replace(" ", "+");
    let citySplit = city?.replace(" ", "+");
    let stateSplit = state;
    setMapsURL(
      `https://www.google.com/maps/search/?api=1&query=${streetSplit}+${citySplit}%2C${stateSplit}`,
    );
  };

  useEffect(() => {
    checkImage();
    getMapsURL(eventStreet1, eventCity, eventState);
  }, [image]);

  return (
    <Card
      sx={{ cursor: "pointer", height: "100%" }}
      style={{ backgroundColor: "#F7F9FC"}}
      // onClick={(e) => {
      //   e.preventDefault();
      //   // Come back to this
      //   if (safetyCheck && appId !== undefined) {
      //     router.push(`/accounts/applied-events/${appId}`); 
      //   }
      //   else if(safetyCheck) {
      //     router.push("/accounts/my-events");
      //   }
      //   else {
      //     router.push(`/events${legacy}/${eventUrl}`);
      //   }
      // }}

      //This is where you edit the event card
    >
      <Grid container spacing={0}>
        <Grid item xs={12} sm={12} margin={0}>
          {window.innerWidth < 600 ? (
            <Box sx={{ position: "relative", width: "100%", height: 150 }}>
              <Image
                src={
                  image
                    ? image
                    : "https://res.cloudinary.com/dkceblkn7/image/upload/v1643205862/stock%20images/boho-market-dallas-texas-1_oc6bjq.jpg"
                }
                alt="Event Image"
                layout="fill"
                objectFit="cover"
                unoptimized
              />
            </Box>
          ) : (
            <Box sx={{ position: "relative", width: "100%", height: 150 }}>
              <Image
                src={
                  image
                    ? image
                    : "https://res.cloudinary.com/dkceblkn7/image/upload/v1643205862/stock%20images/boho-market-dallas-texas-1_oc6bjq.jpg"
                }
                alt="Event Image"
                layout="fill"
                objectFit="cover"
                unoptimized
              />
            </Box>
          )}
        </Grid>
        <Grid item xs={12} margin={1}>
          <Typography variant={"h5"} fontWeight={700}>
            {eventName}
          </Typography>
        </Grid>
        <Grid item xs={12} marginLeft={1} marginBottom={1}>
          <div style={{display: "flex", alignItems: "center"}}>
          <CalendarIcon className="icon--sm" color="accent-light" />
            <Typography variant="body1" fontWeight={700} marginLeft={1}>
              {eventStart === null && eventEnd === null
                ? "Dates TBD"
                : isSameDay(eventStart, eventEnd)
                ? `On ${getFormattedDate(eventStart)}`
                : ` ${getFormattedDate(eventStart)} -
            ${getFormattedDate(eventEnd)}`}
            </Typography>
            </div>
        </Grid>
        {shouldShowSingleTime({ has_varying_times: hasVaryingTimes }) && (
        <Grid item xs={12} marginLeft={1} marginBottom={1}>
          <div style={{display: "flex", alignItems: "center"}}>
          <ClockIcon className="icon--sm" color="accent-light" />
          {eventHours && <p style={{paddingLeft: 5}}>{parse(eventHours)}</p>}
            <p  style={{paddingLeft: 5}}>
              {eventStart === null && eventEnd === null
                ? "Dates TBD"
                : ` ${getFormattedTime(eventHoursStart)} -
            ${getFormattedTime(eventHoursEnd)}`}
            </p>
            </div>
        </Grid>
        )}
        <Grid
          item
          xs={12}
          marginLeft={1}
          onClick={(e) => {
            e.preventDefault();
            router.push(mapsURL);
          }}
        >
          
          <div style={{display: "flex", alignItems: "center", paddingBottom: 2}}>
              <LocationIcon className="icon--sm" color="accent-light" />
              <Typography variant="body1" fontWeight={700} marginLeft={1}>
                {eventStreet1}, {eventCity}
              </Typography>
          </div>
        </Grid>
        <Grid item xs={12} margin={1}>
          {eventStatus && (
            <p style={{ textAlign: "center", display: "block" }}>
              Applications Opening Soon
            </p>
          )}
          {safetyCheck && (
            <p style={{ textAlign: "center", display: "block", fontSize: "large", fontWeight: "bold" }}>
              You have already applied to this event.{" "}
              <br />
              <Link href="/accounts/my-events">Go to My Events</Link>
            </p>
          )}
        </Grid>
        <Grid container>
          <Grid item xs={"auto"} margin={1}>
            <Typography variant="h6"> View Event Details</Typography>
          </Grid>
          <Grid item xs={"auto"} margin={1}>
          <a href={`/events${legacy}/${eventUrl}`} className="event__card__btn">
                {/* <ChevronLeftIcon color="white" /> */}
                <Image
                  src={RightArrow}
                  height="32"
                  width="32"
                  alt="go to event"
                />
              </a>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default EventCard;
